'use client';
import usStates from 'states-us';
import FormControl from '@mui/material/FormControl';
import { InputLabel, Select, MenuItem, SelectChangeEvent, FormHelperText } from '@mui/material';
import React, { ReactNode } from 'react';
import { useTranslations } from 'next-intl';

const stateOptions = usStates
  .filter(el => el.contiguous)
  .map(el => ({ label: el.name, value: el.abbreviation }));

interface Props {
  name: string;
  value?: string | null;
  onChange: (event: SelectChangeEvent<string | null>, child: ReactNode) => void;
  inputRef: React.Ref<unknown>;
  required?: boolean;
  error?: boolean;
  helperText?: string;
}

export const StateSelect: React.FC<Props> = ({
  value,
  onChange,
  inputRef,
  required,
  error,
  helperText,
}: Props) => {
  const t = useTranslations();

  return (
    <FormControl fullWidth required={required} error={error}>
      <InputLabel shrink>{t('Form.state')}</InputLabel>
      <Select value={value} onChange={onChange} inputRef={inputRef} defaultValue="">
        <MenuItem disabled value="">
          {t('Form.select')}
        </MenuItem>
        {stateOptions.map(state => (
          <MenuItem key={state.value} value={state.value}>
            {state.label}
          </MenuItem>
        ))}
      </Select>
      {helperText && <FormHelperText sx={{ mx: 0 }}>{helperText}</FormHelperText>}
    </FormControl>
  );
};
